import { AxiosInstance } from "axios";
import { TerraPaymentConfigMapperRequest } from "data/terra/TerraPaymentConfigMapper";
import { Result, result } from "util/result";

class TerraPaymentEndtrypoint {
    private readonly TERRA_PAYMENT_HOST = window.REACT_APP_TERRA_PAYMENT_API_URL;
    private readonly TERRA_PAYMENT_BASE_API_URL = 'api/v1';

    terraPaymentConfigMapper = () => 
    `${this.TERRA_PAYMENT_HOST}/${this.TERRA_PAYMENT_BASE_API_URL}/configs-mappers`
}

export class TerraPaymentApi {
    private readonly terraClient: AxiosInstance;
    private readonly endpoint: TerraPaymentEndtrypoint;

    public constructor(terraClient: AxiosInstance) {
        this.terraClient = terraClient;
        this.endpoint = new TerraPaymentEndtrypoint();
    }

    postConfigMapper(request: TerraPaymentConfigMapperRequest): Promise<Result<any>> {
        return result(
            async() => (
                await this.terraClient.post<any>(
                    this.endpoint.terraPaymentConfigMapper(),
                    request
                )
            ).data
        )
    }
}